import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

interface ILinkCore {
  isDisabled?: boolean;
  color?: string;
  to: string;
  target?: React.HTMLAttributeAnchorTarget | undefined;
  children: ReactNode;
  onClick?: () => void;
}

export const LinkCore: FC<ILinkCore> = ({
  isDisabled,
  children,
  target,
  onClick,
  color,
  to,
}) => {
  if (isDisabled) {
    return <span>{children}</span>;
  }

  return (
    <Link
      style={{
        outline: "none",
        textDecoration: "none",
        color: color || "#3b3b3b",
      }}
      target={target}
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
